import { htmlE } from "/WebInterface/new-ui/assets/js/utils/te.js";

export const connectionLostTemplate = htmlE`
    <div class="is-flex is-flex-direction-column gap-3 is-justify-content-center is-align-items-center h-full w-full">
        <i class="icon-warning-sign text-accentMain"></i>
        <p data-i18n-key="tryingToReconnectElectronApp" class="text-primaryMain text-sm">${"tryingToReconnectElectronAppText"}</p>
        <button data-i18n-key="tryNow" id="try-now-button" class="primary-button is-bg-none">${"tryNowText"}</button>
    </div>
`;

export const electronUserInfoTemplate = htmlE`
    <div class="electron-app-user-info">
      <p class="text-sm has-text-centered"><span>${"serverText"} </span>: <span>${"servername"}</span></p> 
      <p class="text-sm has-text-centered"><span>${"userText"} </span>: ${"username"}</p>
      <p class="text-sm has-text-centered"><span>${"pathText"} </span>: ${"path"}</p>
    </div>`;
